function AboutAttributesDiseaseDisease() {
  return (
    <div id="section47">
      <h3>Disease-Disease Associations</h3>
      <ul>
        <li className="bullet-item">Jaccard Index based on shared genes</li>
        <li className="bullet-item">
          -log(p-value JIg): we provide the minus decimal logarithm of the p-value of JIg
        </li>
        <li className="bullet-item">Jaccard Index based on shared variants</li>
        <li className="bullet-item">
          -log(p-value JIv): we provide the minus decimal logarithm of the p-value of JIv
        </li>
        <li className="bullet-item">
          p-value: the p-value of the JI (for genes or variants) was obtained by a Fisher test. Only those
          DDAs with p-value equal to or smaller than 10<sup>-6</sup> are included in the dataset (for the
          Jaccard index of the genes or the variants)
        </li>
        <li className="bullet-item">
          The Sokal-Sneath semantic similarity distance{' '}
          <a className="tt" target="_blank" rel="noreferrer" href="https://pubmed.ncbi.nlm.nih.gov/21463704/">
            (Sánchez et al., 2011)
          </a>
          &nbsp; computed on the taxonomic relations (only is-a type) provided by the Unified Medical Language
          System Metathesaurus®. These types of relations can also be retrieved using the DDA Relation
          “is_similar_to” in the disgenet2r R package{' '}
        </li>
        <li className="bullet-item">
          DDA Relation: semantic relations between diseases obtained from the Unified Medical Language System
          Metathesaurus®. The types of relations available are: has_manifestation, has_associated_morphology,
          manifestation_of, associated_morphology_of, is_finding_of_disease, due_to,
          has_definitional_manifestation, has_associated_finding, definitional_manifestation_of,
          disease_has_finding, cause_of, associated_finding_of, is_similar_to.
        </li>
      </ul>
    </div>
  );
}

export default AboutAttributesDiseaseDisease;
